<script>
  import { urlServeur } from "../components/conf.js";
  import Spinner from "../components/ToolsSpinner.svelte";

  let promise;
  let annee;

  const fetchData = async () => {
    const response = await fetch(
      urlServeur + "/api_employe/detailPrimeOneYear"
    );
    if (response.ok == 1) {
      const res = await response.json();
      annee = res.payload.annee;
      //console.log(res.payload);
      return res.payload.data;
    }
  };

  promise = fetchData();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <h6>Détail des primes pour l'année : {annee}</h6>
  <div class="row">
    {#each Object.entries(elements) as [nom, tabPrimes]}
      <div class="row carte">
        <div class="nom col float-sm-left">
          <strong>{nom}</strong>
        </div>
        <div class="total col-4 float-sm-left">
          Primes: <span class={tabPrimes.totalPrimes != 0 ? "gras" : ""}
            >{new Intl.NumberFormat("fr-FR").format(
              tabPrimes.totalPrimes
            )}</span
          >
        </div>
        <div class="total col-4 float-sm-left">
          Découchés: <span class={tabPrimes.P_Decouches != 0 ? "gras" : ""}
            >{new Intl.NumberFormat("fr-FR").format(
              tabPrimes.P_Decouches
            )}</span
          >
        </div>
        <div>
          {#each tabPrimes.Prime as prime}
            <span class="primes col float-sm-left"
              ><span>({prime.mois}) -> </span>{new Intl.NumberFormat(
                "fr-FR"
              ).format(prime.prime)}</span
            >
          {/each}
        </div>
      </div>
    {/each}
  </div>
{/await}

<style>
  .carte {
    margin-bottom: 8px;
    font-size: 0.7em;
    border-bottom: 0.5px solid gray;
    padding-bottom: 3px;
  }
  .primes {
    margin-left: 2px;
  }
  .gras {
    font-weight: bold;
  }
  .nom {
    margin-left: 3px;
  }
</style>
